"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var centerGameObjects = exports.centerGameObjects = function centerGameObjects(objects) {
  objects.forEach(function (object) {
    object.anchor.setTo(0.5);
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/utils.js
// module id = 340
// module chunks = 0